import React from 'react'

import styled from 'styled-components'

import theme from 'app/theme'
import CsgButton from 'components/atoms/Button'

const ErrorButton = styled(({ ...props }) => <CsgButton {...props} />)`
  && {
    ${props =>
      props.variant === 'outlined'
        ? `border-color: ${theme.palette.error.main}; color: ${theme.palette.error.main};`
        : `background-color: ${theme.palette.error.main}; color: ${theme.palette.error.contrastText};`}

    &:hover {
      ${props =>
        props.variant === 'outlined'
          ? `border-color: ${theme.palette.error.dark}; color: ${theme.palette.error.dark};`
          : `background-color: ${theme.palette.error.dark}; color: ${theme.palette.error.contrastText};`}
    }
  }
`

export default ErrorButton
